import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import "./SectionHead.css";

type SectionHeadProps = {
  title: React.ReactNode;
  text?: React.ReactNode;
  /** Botão contornado à direita ("Ver todos →"). `to` começando com "#" vira âncora na própria página. */
  action?: { label: string; to: string };
  /** Linha fina que liga o título ao botão (seção de certificações). */
  rule?: boolean;
  tone?: "light" | "dark";
  id?: string;
  className?: string;
};

// Cabeçalho padrão das seções da Home: traço rosa, título, subtítulo e botão opcional.
export default function SectionHead({ title, text, action, rule, tone = "light", id, className = "" }: SectionHeadProps) {
  const classes = `cz-shead cz-shead--${tone}${rule ? " cz-shead--rule" : ""} ${className}`.trim();
  const actionContent = (
    <>
      {action?.label}
      <ArrowRight size={16} aria-hidden="true" />
    </>
  );

  return (
    <div className={classes}>
      <div className="cz-shead__text">
        <span className="cz-shead__bar" aria-hidden="true" />
        <h2 className="cz-shead__title" id={id}>{title}</h2>
        {text && <p className="cz-shead__desc">{text}</p>}
      </div>
      {rule && <span className="cz-shead__rule" aria-hidden="true" />}
      {action &&
        (action.to.startsWith("#") ? (
          <a href={action.to} className="cz-outline-btn cz-outline-btn--sm cz-shead__action">{actionContent}</a>
        ) : (
          <Link to={action.to} className="cz-outline-btn cz-outline-btn--sm cz-shead__action">{actionContent}</Link>
        ))}
    </div>
  );
}
